import { render, staticRenderFns } from "./DocumentValidation.vue?vue&type=template&id=1e7758fd"
import script from "./DocumentValidation.vue?vue&type=script&lang=js"
export * from "./DocumentValidation.vue?vue&type=script&lang=js"
import style0 from "./DocumentValidation.vue?vue&type=style&index=0&id=1e7758fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports